var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2458 7.4209L19.478 8.18027C16.798 10.8666 13.9292 13.9442 11.2514 16.6599L7.42925 13.5128L6.60238 12.8209L5.22705 14.4915L6.06238 15.1749L10.6524 18.9549L11.4033 19.5793L12.1036 18.8874C15.0061 15.9787 18.1554 12.5719 21.0136 9.70745L21.773 8.93962L20.2458 7.4209Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyNyAyNyIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMC4yNDU4IDcuNDIwOUwxOS40NzggOC4xODAyN0MxNi43OTggMTAuODY2NiAxMy45MjkyIDEzLjk0NDIgMTEuMjUxNCAxNi42NTk5TDcuNDI5MjUgMTMuNTEyOEw2LjYwMjM4IDEyLjgyMDlMNS4yMjcwNSAxNC40OTE1TDYuMDYyMzggMTUuMTc0OUwxMC42NTI0IDE4Ljk1NDlMMTEuNDAzMyAxOS41NzkzTDEyLjEwMzYgMTguODg3NEMxNS4wMDYxIDE1Ljk3ODcgMTguMTU1NCAxMi41NzE5IDIxLjAxMzYgOS43MDc0NUwyMS43NzMgOC45Mzk2MkwyMC4yNDU4IDcuNDIwOVoiIC8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };